import React from "react";

import { BehavioralActions, BehavioralInterventions } from "../BehavioralWorkflowSteps";
import { WorkflowStepTransitionButtons } from "../WorkflowStepTransitionButtons";

import "./styles.scss";

export const BehavioralInterventionAndPlan = (props) => {
  return (
    <div className="BehavioralInterventionAndPlan--container">
      <BehavioralInterventions {...props} />
      <div>
        <BehavioralActions {...props} />
      </div>

      <WorkflowStepTransitionButtons
        currentStep={props.state.currentStep}
        onNextStep={() => {
          props.jumpWorkflowStep(props.state.currentStep + 1);
        }}
        onPreviousStep={() => {
          props.jumpWorkflowStep(props.state.currentStep - 1);
        }}
        workflow={props.state.workflow}
      />
    </div>
  );
};
